<template>
  <div class="PersonSpecificExtraWorkListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      @click:row="handleClick"
    >
       <template v-slot:item.status="{ item }">
        <span>
          {{ getStatus(item.status) }}
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
import StatusType from "@/model/StatusType";

export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("periodOrMonth"),
          value: "PeriodName",
        },
        {
          text: this.$t("specificExtraWork"),
          value: "ExtraWork",
        },
        {
          text: this.$t("RequestDate"),
          value: "RECDATE",
        },
        {
          text: this.$t("status"),
          value: "status",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
    getStatus(status) {
      return StatusType.getStatus(status);
    },
  },
};
</script>

<style>
</style>